import type { Descendant} from 'slate';
import { Node } from 'slate';

import type { SerializedBlock } from '@zoomit/editor';

export const getTypographyRawContent = (data: Descendant[]) => {
  let rawContent = '';
  data.forEach((node) => {
    rawContent += Node.string(node);
  });
  return rawContent;
};

export const isContentAvailable = (blocks?: SerializedBlock[]): boolean => {
  if (!blocks) return false;
  if (blocks.length === 0) return false;

  // check that there is a block other than the typography
  const blockOtherThanTypography = blocks.some(({ type }) => type !== 'typography');
  if (blockOtherThanTypography) return true;

  // check if every typography blocks are empty
  return blocks
    .filter(({ type }) => type === 'typography')
    .every(({ data }) => getTypographyRawContent(data)?.trim() !== '');
};
